import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';

import { AlertType } from '@app/models/alert.type';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
    readonly alertType: InputSignal<AlertType> = input.required();
    readonly title: InputSignal<string> = input.required();
    readonly message: InputSignal<string> = input.required();
}
